const FromCustom = (custom) => {
  const prefix = 'council.primary.';
  if (typeof custom === 'string') {
    return custom.substring(prefix.length);
  }
  const matching = custom.filter(c => c.indexOf(prefix) === 0)
  if (matching.length > 0) return matching[0].substring(prefix.length);
  return '';
};

export default {
  install(Vue) {
    Vue.filter('authority', function (user) {
      return FromCustom(user.custom);
    });
    Vue.prototype.$authority = function (user) {
      return FromCustom(user.custom);
    };
  },
};
